import { type FragmentType, graphql, useFragment } from '@typings/gql'
import { Link as GatsbyLink } from 'gatsby'
import React, { useCallback } from 'react'

import {
  useInbentaKmTracking,
  useInbentaSearchKmItemTracking,
} from '../tracking-utils'

type FaqRowProps = {
  content: FragmentType<typeof FaqRowFragment>
  searchCode?: string
}

export const FaqRow = ({ content, searchCode }: FaqRowProps) => {
  const {
    title,
    url,
    tracking: { clickCode, externalCode },
  } = useFragment(FaqRowFragment, content)

  const sendKmTracking = useInbentaKmTracking({
    type: 'click',
    data: {
      code: clickCode,
    },
  })[1]

  const sendSearchKmEvent = useInbentaSearchKmItemTracking(
    searchCode,
    clickCode,
    externalCode
  )

  const onClick = useCallback(() => {
    if (searchCode) {
      void sendSearchKmEvent()
    } else {
      void sendKmTracking()
    }
  }, [searchCode, sendSearchKmEvent, sendKmTracking])

  return (
    <GatsbyLink
      className="text-100 text-amplification-black-premium group-[.is-dark-mode]/menu:text-white-50 font-normal! hover:opacity-60"
      to={url}
      onClick={onClick}
    >
      {title}
    </GatsbyLink>
  )
}

export const FaqRowFragment = graphql(`
  fragment FaqRow on InbentaSearchItem {
    __typename
    title
    url
    tracking {
      clickCode
      rateCode
      externalCode
    }
  }
`)
